export enum ListItemIconMargin {
  START = "start",
  END = "end"
}

export const LIST_ITEM_ICON_SIZE = 18;
